export const IS_AUTHENTICATED = 'isAuthenticated';

export type ServiceSignInQueries = {
    [IS_AUTHENTICATED]: undefined;
};

export type ServiceSignInQueriesResponseType = {
    [IS_AUTHENTICATED]: boolean | '' | null;
};
